import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import PdpPrice from './PdpPrice';
import { ProductGenderDivision, PageTitle } from '../../components';
import PageHeader from '~COMPONENTS/containers/PageHeader';
import { createProductName } from '../../util/createProductName';

const PdpHeader = ({ rawName, styleName, selectedProductPrices, gender, division, dimensions, sport }) => {
  const pageHeaderTitle = createProductName({
    name: styleName,
    dimensions: dimensions,
    division: division
  });

  return (
    <>
      <PageTitle title={pageHeaderTitle} />
      <div className='body-3 d-sm-h d-md-b'>
        <ProductGenderDivision gender={gender} division={division} sport={sport} />
      </div>
      <PageHeader className='pl0-sm pt1-sm pb4-sm' title={pageHeaderTitle}>
        <p className='mt1-sm text-color-grey body-4'>{rawName}</p>
        <div className='body-4 text-color-secondary d-sm-b d-md-h'>
          <ProductGenderDivision gender={gender} division={division} sport={sport} />
        </div>
      </PageHeader>
      <div className='d-sm-h d-md-b'>
        <PdpPrice selectedProductPrices={selectedProductPrices} />
      </div>
    </>
  );
};

PdpHeader.defaultProps = {
  dimensions: null,
  division: null,
  gender: null,
  sport: null,
  styleName: null,
  rawName: null
};

PdpHeader.propTypes = {
  dimensions: PropTypes.string,
  division: PropTypes.string,
  gender: PropTypes.string,
  selectedProductPrices: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    retail: PropTypes.number.isRequired,
    wholesale: PropTypes.number.isRequired
  }).isRequired,
  sport: PropTypes.string,
  styleName: PropTypes.string,
  rawName: PropTypes.string
};

export default PdpHeader;
